import { Link } from "react-router-dom";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { TaskboardLogo } from "../components/TaskboardLogo";

export function NotFound() {
  useDocumentTitle("Page Not Found");

  return (
    <div className="flex-1 p-8 mx-auto w-full max-w-7xl">
      <div className="text-center py-24">
        <div className="flex justify-center mb-8">
          <TaskboardLogo className="h-16 w-auto" />
        </div>
        <p className="text-7xl font-bold text-gray-600 mb-4">404</p>
        <h1 className="text-3xl font-bold text-white mb-4">Page Not Found</h1>
        <p className="text-lg text-gray-400 mb-8 max-w-md mx-auto">
          The page you are looking for doesn't exist or may have been moved.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="bg-gray-700 hover:bg-gray-600 text-white font-medium py-2.5 px-6 rounded-lg transition-colors"
          >
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}